import React from "react";
import { letterGenderPhrases, parseLetterGender } from "./letterGenderUtils";
import sign from "./sign.png";
type HmContractLetterProps = {
  date?: string;
  candidateName?: string;
  address?: string;
  pageNumber?: number;
  /** From onboarding; drives he/she and him/her in contract clause 8. */
  gender?: string | null;
};

const HmContractLetter: React.FC<HmContractLetterProps> = ({
  date = "DD/MM/YYYY",
  candidateName = "Rimu Dutta",
  address = "Enter candidate address",
  pageNumber = 1,
  gender = null,
}) => {
  const { subjectLower, objectLower } = letterGenderPhrases(parseLetterGender(gender));
  const isFirstPage = pageNumber === 1;
  const isSecondPage = pageNumber === 2;
  const isThirdPage = pageNumber === 3;
  const isFourthPage = pageNumber === 4;
  const isFifthPage = pageNumber === 5;
  const isSixthPage = pageNumber === 6;
  const isSeventhPage = pageNumber === 7;

  return (
    <div
      className="w-[794px] h-[1123px] overflow-hidden bg-white text-black shadow-sm p-8"
      style={{ boxSizing: "border-box", fontFamily: '"Times New Roman", serif' }}
    >
      
      <div className="w-full h-full flex flex-col" style={{ boxSizing: "border-box" }}>
        <div className="flex items-start justify-between border-b border-gray-300 pb-2">
          <div className="pt-0 self-start">
            <img src="/assets/images/earlyjobsCropped.png" alt="EarlyJobs" className="h-20 w-auto object-contain" />
          </div>
          <div className="max-w-[60%] text-left">
            <p className="text-xl font-bold text-[#1e355f]">Victa EarlyJobs Technologies Pvt. Ltd.</p>
            <p className="mt-1 text-sm text-gray-800 leading-snug">
              No. 53, HustleHub, 5th Cross Rd, Near Sony World Signal,<br/> Koramangala, Bengaluru, Karnataka 560034
            </p>
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between text-base">
          <p>Dated: {date}</p>
          <p>Freelance Recruiter Contract</p>
        </div>

        <div className="mt-5 flex-1 flex flex-col">
          {isFirstPage && (
            <div className="space-y-2 text-[19px] leading-[1.36]">
              <p className="text-center text-xl font-bold underline">Freelance Recruiter Contract</p>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; This Freelance Contract is made as of this {date}, by and between Victa Earlyjobs Technologies Pvt.
                Ltd., Bengaluru and {candidateName}, located at {address}. Client and Independent Freelancer may each
                be referred to in this Agreement as a "Party" and collectively as the "Parties".
              </p>
              <br />
              <div className="mt-3 space-y-1">
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">1.</span>
                  <p className="flex-1">
                    Services- Independent Freelancer shall provide the following services to Earlyjobs (the
                    “Recruitment Services”) – Hiring Candidates for various companies and locations as per the job
                    description given BY Earlyjobs USING INDEPENDENT FREELANCER’S own methodologies. In addition,
                    Independent Freelancer shall perform such other duties and tasks, or changes to the Services, as
                    may be agreed upon by the Parties.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">2.</span>
                  <p className="flex-1">
                    Compensation: The independent freelancer will raise an invoice for the number of candidates who
                    completed 90 days of work after joining the company.(For each position, fixed or percentage are
                    mentioned on Earlyjobs portal)
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">3.</span>
                  <p className="flex-1">
                    Expenses- All costs and expenses incurred by the Independent Freelancer in connection with the
                    performance of the Services shall be the sole responsibility of and paid by Independent Freelancer.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">4.</span>
                  <p className="flex-1">
                    Term and Termination- Independent Freelancer’s engagement with Earlyjobs under this Agreement shall
                    commence of the contract. The Parties agree and acknowledge that this Agreement and Independent
                    Freelancer&apos;s engagement with Earlyjobs under this Agreement shall terminate after one (1) year.
                  </p>
                </div>
              </div>
            </div>
          )}

          {isSecondPage && (
            <div className="space-y-2 text-[19px] leading-[1.36]">
              <div className="space-y-1">
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">5.</span>
                  <p className="flex-1">
                    Independent Freelancer- The Parties agree and acknowledge that Independent Freelancer is an
                    independent Freelancer and is not, for any purpose, an employee of Earlyjobs. Independent
                    Freelancer does not have any authority to enter into agreements or contracts on behalf of
                    Earlyjobs, and shall not represent that it possesses any such authority. Independent Freelancer
                    shall not be entitled to any of Earlyjob's benefits including, but not limited to, coverage under
                    medical, dental, retirement, or other plans. Earlyjobs shall not be obligated to pay
                    worker&apos;s compensation insurance, unemployment compensation, social security tax, withholding
                    tax, or other taxes or withholdings for or on behalf of the Independent Freelancer in connection
                    with the performance of the Services under this Agreement. Nothing contained in this Agreement
                    shall be deemed or construed by the Parties to create the relationship of a partnership, a joint
                    venture, or any other fiduciary relationship.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">6.</span>
                  <div className="flex-1">
                    <p>Confidentiality-</p>
                    <div className="mt-1 space-y-1">
                      <div className="flex items-start gap-3">
                        <span className="w-7 shrink-0 text-right">a.</span>
                        <p className="flex-1">
                          Confidential and Proprietary Information. In the course of performing the Services,
                          Independent Freelancer will be exposed to confidential and proprietary information of
                          Earlyjobs. &quot;Confidential Information&quot; shall mean any data or information that is
                          competitively sensitive material and not generally known to the public, including, but not
                          limited to, information relating to development and plans, marketing strategies, finance,
                          operations, systems, proprietary concepts, documentation, reports, data, specifications,
                          computer software, source code, object code, flowcharts, data, databases, inventions,
                          know-how, trade secrets, customer lists, customer relationships, customer profiles, supplier
                          lists, supplier relationships, supplier profiles, pricing, sales estimates, business plans
                          and internal performance results relating to the past, present or future business activities,
                          technical information, designs, processes, procedures, formulas or improvements, which
                          Earlyjobs considers confidential and proprietary.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {isThirdPage && (
            <div className="space-y-2 text-[19px] leading-[1.36]">
              <div className="space-y-1">
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">b.</span>
                  <p className="flex-1">
                    Confidentiality Obligations. Except as otherwise expressly permitted in this Agreement,
                    Independent Freelancer shall not disclose or use in any manner, directly or indirectly, any
                    confidential information either during the term of this Agreement or at any time thereafter, except
                    as required to perform the Services or with Earlyjobs&apos;s prior written consent. Independent
                    Freelancer shall not at any time directly connect with the student nor disclose their
                    freelance association status to the student.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">c.</span>
                  <p className="flex-1">
                    Rights in Confidential Information. All Confidential Information disclosed to Independent
                    Freelancer by Earlyjobs: (i) is and shall remain the sole and exclusive property of Earlyjobs,
                    and (ii) is disclosed or permitted to be acquired by Independent Freelancer solely in reliance on
                    Independent Freelancer&apos;s agreement to maintain the Confidential Information in confidence and
                    not to use or disclose the Confidential Information to any other person. Except as expressly
                    provided herein, this Agreement does not confer any right, license, ownership, or other interest
                    in or title to the Confidential Information to the Independent Freelancer.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">d.</span>
                  <p className="flex-1">
                    Irreparable Harm. Independent Freelancer acknowledges that the use or disclosure of any
                    Confidential Information in a manner inconsistent with this Agreement will give rise to irreparable
                    injury for which damages would not be an adequate remedy. Accordingly,
                  </p>
                </div>
              </div>
              <br />
              <p>
                in addition to any other legal remedies which may be available at law or in equity, Earlyjobs shall be entitled to equitable or injunctive relief against the unauthorized use or disclosure of Confidential Information. Earlyjobs shall be entitled to pursue any other legally permissible remedy available as a result of such breach, including but not limited to, damages, both direct and consequential. In any action brought by Earlyjobs under this Section, Earlyjobs shall be entitled to recover its attorney’s fees and costs from Independent Freelancer.
                e. Any information/assignments/test papers etc shared with students must be emailed (CC) to the Client’s official E-Mail ID without fail.
              </p>
            </div>
          )}

          {isFourthPage && (
            <div className="space-y-2 text-[19px] leading-[1.36]">
              <div className="space-y-2">
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">7.</span>
                  <p className="flex-1">
                    Ownership of Work Product. The Parties agree that all work product, information, or other
                    materials created and developed by Independent Freelancer in connection with the performance of the
                    Services under this Agreement and any resulting intellectual property rights (collectively, the
                    “Work Product”) are the sole and exclusive property of Earlyjobs. The Parties acknowledge that the
                    Work Product shall, to the extent permitted by law, be considered a “work made for hire” within
                    the definition of the Copyright Act of 1976, as amended, (the “Copyright Act”) and that Earlyjobs.
                    is deemed to be the author and is the owner of all copyright and all other rights therein. If the
                    work product is not deemed to be a “work made for hire” under the Copyright Act, then Independent
                    Freelancer hereby assigns to Earlyjobs. all of Independent Freelancer’s rights, title, and
                    interest in and to the Work Product, including but not limited to all copyrights, publishing
                    rights, and rights to use, reproduce, and otherwise exploit the Work Product in any formats, media,
                    or all channels, whether now known or hereafter created.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">8.</span>
                  <div className="flex-1">
                    <p>On-Boarding / Session Timings / Leave:</p>
                    <div className="mt-1 space-y-1">
                      <div className="flex items-start gap-3">
                        <span className="w-7 shrink-0 text-right">a.</span>
                        <p className="flex-1">
                          As a part of the successful onboarding of the Independent Freelancer with Earlyjobs,{" "}
                          {subjectLower} has to conduct TWO DEMO Hiring for a fair evaluation of the expertise of the
                          Independent Freelancer.
                        </p>
                      </div>
                      <div className="flex items-start gap-3">
                        <span className="w-7 shrink-0 text-right">b.</span>
                        <p className="flex-1">
                          The Independent Freelancer shall disclose to the Client the available timings of {objectLower}
                        </p>
                      </div>
                      <div className="flex items-start gap-3">
                        <span className="w-7 shrink-0 text-right">c.</span>
                        <p className="flex-1">for offering the services at the time of Onboarding itself and shall abide by the same timings in due course.</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">9.</span>
                  <p className="flex-1">
                    Non-Compete. Independent Freelancer agrees and covenants that during the term of this Agreement,
                    and for a period of 11 months following the termination of this Agreement, Independent Freelancer
                    will not, directly or indirectly, perform or engage in the same or similar activities as were
                    performed for Earlyjobs. for any business that is directly or indirectly in competition with
                    Earlyjobs.
                  </p>
                </div>
              </div>
            </div>
          )}

          {isFifthPage && (
            <div className="space-y-2 text-[19px] leading-[1.36]">
              <div className="pr-6 space-y-2">
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">10.</span>
                  <p className="flex-1">
                  Non-Solicit. Independent Freelancer agrees and covenants that for a period of 11 months following the termination of this Agreement,
                  Independent Freelancer will not, directly or indirectly, solicit any officer, director or employee, or any customer, Earlyjobs, supplier or vendor of. for the purpose of inducing such party to terminate its relationship with Earlyjobs in favor of an Independent Freelancer or another business directly or indirectly in competition with Earlyjobs
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">11.</span>
                  <p className="flex-1">
                  Mutual Representations and Warranties.
                  Both Earlyjobs and Independent Freelancer represent and warrant that each Party has full power, authority, and right to execute and deliver this Agreement, has full power and authority to perform its obligations under this Agreement,
                  and has taken all necessary action to authorize the execution and delivery of this Agreement.
                  No other consents are necessary to enter into or perform this Agreement.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">12.</span>
                  <p className="flex-1">
                  Independent Freelancer Representation and Warranties.
                  Independent Freelancer represents and warrants that it has all the necessary licenses, permits, and registrations, if any,
                  required to perform the Services under this Agreement in accordance with applicable federal,
                  state and local laws, rules and regulations and that it will perform the Services according to the Earlyjobs’s guidelines and specifications and with the standard of care prevailing in the industry.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">13.</span>
                  <p className="flex-1">
                  Indemnification. The Independent Freelancer shall indemnify and hold harmless Earlyjobs from any damages,
                  claims, liabilities, loss, and expenses, including reasonable attorney’s fees,
                  arising out of any act or omission of Independent Freelancer in performing the Services or the breach of any provision of this Agreement by Independent Freelancer.
                  </p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="w-7 shrink-0 text-right">14.</span>
                  <p className="flex-1">
                  Governing Law. The terms of this Agreement and the rights of the Parties hereto shall be governed exclusively by the laws of the State of Karnataka, without regard to its conflicts of law provisions.
                  </p>
                </div>
              </div>
              {/* <p>
                IN WITNESS WHEREOF, this Agreement has been executed and delivered as of the date first written above.
              </p>
              <div className="pt-4">
                <p>With Best Wishes,</p>
                <p className="mt-1">Early Jobs - Victaman Enterprises</p>
                <p>Director, Bangalore</p>
              </div>
              <p className="pt-4">
                I have read, understood and accepted all the contract details. I understand that the terms and
                conditions listed are pre-conditions to my being offered freelancing with the organization.
              </p>
              <div className="pt-4 space-y-1">
                <p>Name: ____________________</p>
                <p>Date: ____________________</p>
                <p>Signature: ____________________</p>
                <p>Place: ____________________</p>
              </div> */}
            </div>
          )}

          {isSixthPage && <div className="space-y-2 text-[19px] leading-[1.36]">
            <div className="space-y-2">
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">15.</span>
                <p className="flex-1">
                Disputes. Any dispute arising from this Agreement shall be resolved through mediation.
                If the dispute cannot be resolved through mediation, then the dispute will be resolved through binding arbitration conducted in accordance with the rules of the Indian Arbitration Law.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">16.</span>
                <p className="flex-1">
                Binding Effect. This Agreement shall be binding upon and inure to the benefit of the Parties and their respective successors and permitted assigns.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">17.</span>
                <p className="flex-1">
                Entire Agreement. This Agreement constitutes the entire agreement between the Parties hereto with respect to the subject matter hereof and supersedes all prior negotiations, understandings, and agreements of the Parties.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">18.</span>
                <p className="flex-1">
                Amendments. Earlyjobs has complete authority to modify or amend this Agreement from time to time for mutual benefit and it will be binding on both Parties.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">19.</span>
                <p className="flex-1">
                Notices. Any notice or other communication given or made to either Party under this Agreement shall be in writing and delivered by hand, sent by overnight courier service or sent by certified or registered mail, return receipt requested,
                to the address stated above or to another address as that Party may subsequently designate by notice and shall be deemed given on the date of delivery.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">20.</span>
                <p className="flex-1">
                Waiver. Neither Party shall be deemed to have waived any provision of this Agreement or the exercise of any rights held under this Agreement unless such waiver is made expressly and in writing.
                A waiver by either Party of a breach or violation of any provision of this Agreement shall not constitute a waiver of any subsequent or other breach or violation.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">21.</span>
                <p className="flex-1">
                Further Assurances. At the request of one Party, the other Party shall execute and deliver such other documents and take such other actions as may be reasonably necessary to effect the terms of this Agreement.
                </p>
              </div>
              <div className="flex items-start gap-3">
                <span className="w-7 shrink-0 text-right">22.</span>
                <p className="flex-1">
                Severability. If any provision of this Agreement is held to be invalid, illegal, or unenforceable in whole or in part, the remaining provisions shall not be affected and shall continue to be valid, legal, and enforceable as though the invalid, illegal, or unenforceable parts had not been included in this Agreement.
                </p>
              </div>
            </div>
          </div>}
          {isSeventhPage && <div className="space-y-2 text-[19px] leading-[1.36]">
            <p>
              IN WITNESS WHEREOF, this Agreement has been executed and delivered as of the date first written above.
            </p>

            <br />
            <p>With Best Wishes,</p>
            <p>For Victa EarlyJobs Technologies Pvt. Ltd</p>

            <div className="flex flex-col items-end justify-end">
                <p>With Best Wishes, </p>
                <p>For Victa Earlyjobs Technologies Pvt. Ltd</p>
                <img src={sign} alt="sign" className="w-[40%] h-30 mt-1" />
                <p>Authorized Signatory</p>
                <p>Bangalore</p>
              </div>

            <p className="text-sm text-gray-600 mt-1">
              Date: {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
            </p>
            <p>Bangalore</p>


            <br/>
            <br/>

            <p>I have read, understood and accepted all the contract details. I understand that the terms and conditions listed are pre-conditions to my being offered freelancing with the organization. I am under no oblgation accept these term and conditions 
              of this contract I accept them onf my own free choice and will. I opt the follwoing method as a token of commitment to my contact.
            </p>
            <br/>
            <div className="pt-1 space-y-1">
              <p>Name: ____________________</p>
              <p>Date: ____________________</p>
              <p>Signature: ____________________</p>
              <p>Place: ____________________</p>
            </div>
          </div>}
        </div>

        <div className="mt-4 border-t border-dashed border-gray-300 pt-3 text-sm">
          <div className="flex items-center justify-between">
            <p>www.earlyjobs.in</p>
            <p>hr@earlyjobs.in</p>
            <p>+91 8217527926</p>
          </div>
          <p className="mt-1 text-center text-[#d77a35]">Hire your ideal team.10X Quicker.</p>
         
        </div>
      </div>
    </div>
  );
};

export default HmContractLetter;
